// extracted by mini-css-extract-plugin
export default {"Track":"track_Track__2s5fm","Artist":"track_Artist__zjB1Z","Song":"track_Song__QFyqX"};